import { PaginationResult } from '../../models';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import { catchError } from 'rxjs/operators';

export class FullSearchBaseApiService<T> extends BaseApiService<T> {
	public fullFindPageableObjects(
		pageNumber: number,
		pageSize: number,
		sort: string,
		searchObject: string | object,
		apiUrl: string = this.apiUrl
	): Observable<PaginationResult<T>> {
		searchObject = this.prepareSearchQuery(searchObject);
		const url = apiUrl + '?page=' + pageNumber + '&size=' + pageSize + '&query=' + searchObject + '&sort=' + sort;
		return this._restClientService.get(url).pipe(catchError(this.handleError));
	}
}
